export class MappingEngine {
  resolve(
    mapping: Record<string, string> | undefined,
    payload: Record<string, unknown>,
  ): Record<string, unknown> | undefined {
    if (!mapping) return undefined;

    const result: Record<string, unknown> = {};

    for (const [targetKey, sourcePath] of Object.entries(mapping)) {
      if (sourcePath === '*') {
        return payload;
      }

      if (sourcePath.startsWith("'") && sourcePath.endsWith("'")) {
        result[targetKey] = sourcePath.slice(1, -1);
        continue;
      }

      result[targetKey] = this.resolvePath(sourcePath, payload);
    }

    return result;
  }

  private resolvePath(path: string, data: Record<string, unknown>): unknown {
    const normalizedPath = path.startsWith('payload.')
      ? path.slice('payload.'.length)
      : path;

    const parts = normalizedPath.split('.');
    let current: unknown = data;

    for (const part of parts) {
      if (current == null || typeof current !== 'object') return undefined;
      current = (current as Record<string, unknown>)[part];
    }

    return current;
  }
}
